import React from 'react';
import { seatLabel } from '../../utils/seats';

interface SeatPillProps {
  seatNumber?: number | null;
  /** Muestra "Compartido" cuando no hay comensal (por defecto no muestra nada). */
  showShared?: boolean;
  size?: 'small' | 'default';
  style?: React.CSSProperties;
}

/**
 * Etiqueta "C1", "C2"... del comensal que pidió un renglón. Un solo componente
 * para que la captura, la mesa, el KDS y la división se lean igual.
 */
const SeatPill: React.FC<SeatPillProps> = ({ seatNumber, showShared = false, size = 'default', style }) => {
  if (!seatNumber && !showShared) return null;
  const className = `seat-pill${seatNumber ? '' : ' seat-pill--shared'}${size === 'small' ? ' seat-pill--sm' : ''}`;
  return (
    <span className={className} style={style} aria-label={seatNumber ? `Comensal ${seatNumber}` : 'Compartido'}>
      {seatNumber ? seatLabel(seatNumber) : 'Compartido'}
    </span>
  );
};

export default SeatPill;
